export const SET_JOBS_VIEW_BY = "SET_JOBS_VIEW";
export const SET_JOBS_VIEW_BY_ACTIVE = "SET_JOBS_VIEW_BY_ACTIVE";

export const defaultJobViewByState = {
  jobsViewBy: [],
  active: false,
};

export default (state = defaultJobViewByState, action) => {
  switch (action.type) {
    case SET_JOBS_VIEW_BY:
      const s = { ...state };
      s.jobsViewBy = {};
      return {
        ...s,
        jobsViewBy: [...action.data]
      };
    case SET_JOBS_VIEW_BY_ACTIVE:
      return {
        ...state,
        active: action.data
      };
    default:
      return state;
  }
};
